import { createAction } from 'redux-starter-kit';
import api from 'api/templates';
import apiUmbrella from 'api/umbrella-backend';
import { selectBundleType } from 'actions/user';

export const fetchTemplates = createAction('templates/FETCH_START');
export const fetchTemplatesSuccess = createAction('templates/FETCH_SUCCESS');
export const fetchTemplatesFailure = createAction('templates/FETCH_FAILURE');
export const setRelatedSearches = createAction('templates/SET_RELATED_SEARCHES');

export const cacheSettings = createAction('templates/CACHE_SETTINGS');
export const resetSettings = createAction('templates/RESET_SETTINGS');
export const clearResults = createAction('templates/CLEAR_RESULTS');

export const searchFor = createAction('templates/SEARCH');
export const setSearchFor = createAction('templates/SET_SEARCH');
export const filterByCateg = createAction('templates/FILTER_BY_CATEG');
export const changeOrder = createAction('templates/CHANGE_ORDER');

export const preloadTemplate = createAction('template/PRELOAD');
export const fetchTemplate = createAction('template/FETCH_START');
export const fetchTemplateSuccess = createAction('template/FETCH_SUCCESS');
export const fetchTemplateFailure = createAction('template/FETCH_FAILURE');

export const asyncFetchTemplates = more => async (dispatch, getState) => {
  // determine if there is any change in state that would trigger a fetch
  const { list, searchFor, categId, prevState } = getState().templates;
  const settingsDifferent = JSON.stringify({ searchFor, categId }) !== prevState;
  if (settingsDifferent) {
    dispatch(clearResults());
  }
  if (more || settingsDifferent || !list.length) {
    dispatch(fetchTemplates());
    api
      .fetchTemplates(paramsFromState(getState()))
      .then(results => {
        dispatch(fetchTemplatesSuccess(results.templates || results));
        if (results.related_searches) {
          dispatch(setRelatedSearches(results.related_searches));
        } else {
          dispatch(setRelatedSearches([]));
        }
        dispatch(cacheSettings());
      })
      .catch(error => dispatch(fetchTemplatesFailure({ error: error.message })));
  }
};

export const asyncSearchForTemplates = (term, type = null) => async dispatch => {
  if (type) dispatch(selectBundleType(type));
  dispatch(searchFor(term));
  dispatch(asyncFetchTemplates());
};

export const changeSearchForTemplates = term => async dispatch => {
  dispatch(setSearchFor(term));
};

export const asyncFilterTemplatesByCateg = categ => async (dispatch, getState) => {
  // dispatch(resetSettings());
  dispatch(filterByCateg(categ));
  dispatch(asyncFetchTemplates());
};

export const asyncFetchTemplate = templateId => async dispatch => {
  const requests = [api.fetchTemplate(templateId), apiUmbrella.fetchMappedProduct('template', templateId)];

  dispatch(fetchTemplate());

  Promise.all(requests)
    .then(([template, data]) => {
      if (data) {
        template.clickFunnelsProductId = data.clickFunnelsProductId;
      }

      dispatch(fetchTemplateSuccess(template));
    })
    .catch(error => dispatch(fetchTemplateFailure({ error: error.message })));
};

const paramsFromState = state => {
  const { batchSize, searchFor, currentPage, categId, orderBy } = state.templates;
  return {
    search_for: searchFor,
    per_page: batchSize,
    categ_id: categId,
    page: currentPage + 1,
    order_by: orderBy
  };
};
